import React from "react";
import "../App.css";
import { Link } from "react-router-dom";

const FrontPage = () => {
  return (
    <div className=" max-w-8xl mx-auto  p-6  lg:mb-20">
      <div className=" lg:flex bg-gradient-to-br  ">
        <div className="lg:w-1/2 sm:w-full flex flex-col items-start p-6 mb-5  mt-10">
          <h1 className=" sm: text-3xl md:text-4xl lg:text-6xl font-bold text-gray-800 mb-4">
            DevOps & VoIP{" "}
            <span className="text-green-600">Consulting Services</span>{" "}
            in
            <span className="text-yellow-500"> India</span>
          </h1>
          {/* Show this paragraph only on large screens */}
          <p className="hidden lg:block text-2xl text-gray-600 mb-6">
            Ayanshtech Solutions is a trusted DevOps &  <a className="  relative   
  before:content-[''] before:absolute before:left-1/2 before:-bottom-1 
  before:h-[2px] before:w-0 before:bg-green-600 
  before:transition-all before:duration-300 
  hover:before:left-0 hover:before:w-full text-green-600 font-bold" href="https://ayanshtechnology.com/sms-broadcasting-system"> VoIP consulting services in India</a>, helping businesses upgrade their communication systems and streamline software delivery. We specialize in secure VoIP development, AI voice solutions, cloud setup, and CI/CD automation to ensure smooth, reliable, and scalable performance.<br /> Our VoIP & DevOps as a Service model uses automation, cloud integration, and continuous monitoring to improve efficiency, speed up releases, and simplify daily operations.<br /> With <strong>10+ years</strong> of experience, we deliver fast onboarding, end-to-end setup, and ongoing optimization across leading cloud and communication platforms—ensuring high availability, security, and better productivity for your business.
          </p>

          {/* Smaller button aligned to the left */}
          <Link to="/contactus">
            <button className="bg-gradient-to-r from-blue-600 to-green-500 text-white hover:to-blue-700 px-4 py-2 rounded-full">
              Start the Conversation!
            </button>
          </Link>
        </div>

        <div className="animated-image lg:w-1/2 sm:w-full relative px-6 py-6 mt-15 ">
          {/* Display all images on large screens */}
          <div className="hidden lg:block">
            <a href="/voip-business-solutions" rel="noopener noreferrer">
              <img
                src="/assets/images/banner/voip.webp"
                alt="VoIP Solutions"
                className="absolute top-[24%] left-[32%] w-[300px]  border-2 border-transparent rounded-lg transition-all duration-300 hover:border-green-500 hover:scale-105"
              />
            </a>
            <a href="/devops-services" rel="noopener noreferrer">
              <img
                src="/assets/images/banner/devops.png"
                alt="Devops solutions"
                className="absolute top-[3%] left-[67%] w-[160px]  border-2 border-transparent rounded-lg transition-all duration-300 hover:border-green-500 hover:scale-105"
              />
            </a>
            <a href="/web-mobile-solutions" rel="noopener noreferrer">
              <img
                src="\assets\images\banner\web.png"
                alt="Web Development"
                className="absolute top-[5%] left-[8%] w-[170px]  border-2 border-transparent rounded-lg transition-all duration-300 hover:border-green-500 hover:scale-105"
              />
            </a>
            <a href="/mobile-app-dev" rel="noopener noreferrer">
              <img
                src="https://whitelabelfox.com/services-assets/images/mobile-app-development/mobile-app-development-hero-section-image.webp"
                alt="Web Mobile Solutions"
                className="absolute top-[60%] left-[8%] w-[200px]  border-2 border-transparent rounded-lg transition-all duration-300 hover:border-green-500 hover:scale-105"
              />
            </a>
            <a href="/streaming-platform" rel="noopener noreferrer">
              <img
                src="https://mercurialminds.com/wp-content/uploads/2023/07/Laptop-tab-mobile-Mockup.png"
                alt="ott streaming"
                className="absolute top-[60%] left-[67%] w-[180px]  border-2 border-transparent rounded-lg transition-all duration-300 hover:border-green-500 hover:scale-105"
              />
            </a>
          </div>

          {/* Show only one image on small and medium screens */}
          <div className="lg:hidden ">
            <div className="animated-image">
              <img
                src="/assets/images/banner/groupCards.png"
                alt="Group Cards"
                className="block mx-auto mt-2 border-2 border-transparent rounded-lg transition-all duration-300 hover:border-green-500 hover:scale-105"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default FrontPage;
